<template>
  <div class="page-content">
    <page-template ref="stockTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
                   @searchReset="searchReset"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  import date from '@/mixin/date'

  export default {
    mixins: [userPower, date],
    components: {
      pageTemplate,
    },
    data() {
      return {
        printShow: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '业务单号',
              prop: 'orderNo',
              type: 'input',
              ifFuzzy: true,
              placeholder: '请输入业务单号',
            },
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24,
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              isHasAll: true,
              url: api.store.store,
              change: this.getSupplier,
            },
            {
              label: "仓库名称",
              type: "select",
              prop: "warehouseId",
              span: 8,
              data: [],
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              data: [],
              // url: api.archives.supplier,
            },
            {
              label: '审核状态',
              type: 'select',
              prop: 'reviewerStatus',
              defaultValue: 20,
              data: [
                {label: '未审核', value: 20},
                {label: '已审核', value: 10}
              ],
            },
          ],
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addRequisition,
          },
          {
            label: '打印',
            code: 'print',
          },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            },
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '240',
              align: 'center',
              //showDetail: true,
              callback: this.goOrderDetail
            },
            {
              label: '仓库名称',
              prop: 'warehouseName',
              width: '180',
              align: 'center',
            },
            {
              label: '供应商名称',
              prop: 'supplierName',
              width: '180',
              align: 'center',
            },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus(
                'pcPurchaseStorageOrder.reviewerStatus'
              ),
            },
            {
              label: '单据金额',
              prop: 'orderAmt',
              width: '100',
              align: 'center',
            },
            // {
            //   label: '商品数量',
            //   prop: 'goodsNum',
            //   width: '120',
            //   align: 'center',
            // },
            {
              label: '制单人',
              prop: 'voucherName',
              width: '120',
              align: 'center',
            },
            {
              label: '制单日期',
              prop: 'voucherDttm',
              width: '150',
              align: 'center',
            },
            {
              label: '审核人',
              prop: 'reviewerName',
              width: '120',
              align: 'center',
            },
            {
              label: '审核日期',
              prop: 'reviewerDttm',
              width: '150',
              align: 'center',
            },
            {
              label: '备注',
              prop: 'remarks',
              align: 'center',
              width: '125',
            },
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()}
          // url: api.purchase.stock,
        },
        //详情
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png',
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: '130',
          columns: [
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
            },
            {
              label: '采购门店',
              prop: 'storeName',
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierName',
            },
            {
              label: '门店仓库',
              type: 'select',
              prop: 'warehouseName',
            },
            {
              label: '经手人',
              prop: 'handler',
            },
            {
              label: '采购订单',
              prop: 'purchaseOrderNo',
            },
            {
              label: '来货日期',
              prop: 'goodsArriveDttm',
            },
            {
              label: '备注',
              prop: 'remarks',
            },
          ],
          tablesProp: {
            pcGoodsMapList: {
              url: api.purchase.goods + "/page",
              height: this.detailHeight,
              showSummary: true,
              indexShow: true,
              tableName: 'pcGoodsMapList',
              summaryColumns: ['goodsNum', 'giveGoodsNum', 'totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '150',
                  align: 'center',
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  width: '90',
                  align: 'center',
                },
                {
                  label: '规格',
                  prop: 'specs',
                  width: '60',
                  align: 'center',
                },
                {
                  label: '单位',
                  width: '60',
                  prop: 'unitName',
                  align: 'center',
                },
                {
                  label: '自编码',
                  width: '120',
                  prop: 'artNo',
                  align: 'center',
                },
                // {
                //   label: '档案进价',
                //   width: '90',
                //   prop: 'buyPrice',
                //   align: 'center',
                // },
                {
                  label: '实际入库数量',
                  width: '130',
                  prop: 'goodsNum',
                  align: 'center',
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsNum',
                  align: 'center',
                },
                {
                  label: '进价',
                  width: '120',
                  prop: 'price',
                  align: 'center',
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: 'center',
                },
                {
                  label: '小计金额',
                  width: '120',
                  prop: 'totalPrice',
                  align: 'center',
                },
                {
                  label: '生产日期',
                  prop: 'produceDttm',
                  width: '220',
                  align: 'center',
                },
                {
                  label: '零售价',
                  width: '120',
                  prop: 'retailPrice',
                  align: 'center',
                },
                {
                  label: '零售金额',
                  width: '90',
                  prop: 'salesAmount',
                  align: 'center',
                },
                {
                  label: '采购未入库数量',
                  width: '130',
                  prop: 'noStorageNum',
                  align: 'center',
                },
                {
                  label: '系统库存',
                  prop: 'inventoryNum',
                  width: '90',
                  align: 'center',
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '150',
                  align: 'center',
                },
              ],
            },
          },
          // 打印的列表
          printTablesProp: {
            pcGoodsMapList: {
              tableName: 'pcGoodsMapList',
              showSummary: true,
              summaryColumns: ['totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '150',
                  align: 'center',
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  width: '90',
                  align: 'center',
                },
                // {
                //   label: '规格',
                //   prop: 'specs',
                //   width: '90',
                //   align: 'center',
                // },
                {
                  label: '单位',
                  width: '60',
                  prop: 'unitName',
                  align: 'center',
                },
                // {
                //   label: '自编码',
                //   width: '120',
                //   prop: 'artNo',
                //   align: 'center',
                // },
                {
                  label: '零售价',
                  width: '120',
                  prop: 'retailPrice',
                  align: 'center',
                },
                {
                  label: '进货价',
                  width: '90',
                  prop: 'buyPrice',
                  align: 'center',
                },
                {
                  label: '实际入库数量',
                  width: '130',
                  prop: 'goodsNum',
                  align: 'center',
                },
                {
                  label: '采购未入库数量',
                  width: '130',
                  prop: 'noStorageNum',
                  align: 'center',
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsNum',
                  align: 'center',
                },
                {
                  label: '小计金额',
                  width: '120',
                  prop: 'totalPrice',
                  align: 'center',
                },
              ],
            },
          },
          url: api.purchase.stock,
        },
      };
    },
    beforeCreate() {
      this.detailHeight = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.setStore(this.searchOptions.complex);
      this.setSupplier(this.searchOptions.complex);
      let userInfo = this.$utils.getSysUser();
      if (userInfo.storeId) {
        this.getSupplier(userInfo)
      }
      this.$nextTick(() => {
        this.tableOptions.url = api.purchase.stock
        this.$refs['stockTemplate'].operationSuccess();
      })
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      this.$nextTick(() => {
        this.tableOptions.url = api.purchase.stock
        this.$refs['stockTemplate'].operationSuccess();
      })
    },
    methods: {
      // 搜索重置
      searchReset() {
        let userInfo = this.$utils.getSysUser();
        if (!userInfo.storeId) {
          this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        }
      },
      getSupplier(param) {
        param.supplierId = '';
        param.warehouseId = ''
        let supplierId = this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0];
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {
          storeId: param.storeId,
          type: 10
        }).then(data => {
          if (data.code === 200) {
            supplierId.data = data.data;
          }
        });
        let warehouseId = this.searchOptions.complex.filter(item => item.prop === 'warehouseId')[0];
        this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {
          storeId: param.storeId
        }).then(data => {
          if (data.code === 200) {
            warehouseId.data = data.data;
          }
        });
      },
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/purchase/stock/detail?id=' + row.id,
          query: {redirect: '/purchase/stock'}
        }).catch(err => {
        });
      },
      addRequisition() {
        this.$router.push({path: '/purchase/stock/add'});
      },
      toEditPage(row) {
        this.$router
          .push({path: '/purchase/stock/add?id=' + row.id})
          .catch((err) => {
          });
      },
      goodsDetailExport() {
        let selectData = this.$refs["stockTemplate"].$refs["tableTemp"].selectRow;
        if (selectData.length === 0) {
          this.$confirm('请选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          if (selectData.length > 1) {
            this.$confirm('只能选择一条数据！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs["stockTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
            })
          } else {
            console.log(selectData[0].orderNo);
            this.$axios.fetchPost(api.purchase.stockExport, {
              orderNo: selectData[0].orderNo,
              exportCode: 'PcPurchaseOrderExport'
            }).then(data => {
              if (data.code === 200) {
                const elink = document.createElement('a');
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: '导出操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: '导出操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            })
          }
        }
      }
    },
  };
</script>




// WEBPACK FOOTER //
// src/page/purchase/Stock.vue